module.exports = __webpack_public_path__ + "img/SN.674eac1f.png";